/*
Sohel 11/02/2022 2699823790 Added Attached Trigger Table
Sohel 11/02/2022 2699823790 Label Changes
Sohel 11/03/2022 2699823790 Added disabled condition
Rajesh 12/15/2022 2699823790 added role access
Ashraf 12/15/2022 2699823790 fixed role access
Ashraf 01/09/2023 2699823790 fixed role based access
Raghu 02/22/2023 2699823790 added new class for button
Guru Prasad 04/04/2023 2699823790 changed popup width
Akhila 04/04/2023 2699823790 added table colum corporate site company
Akhila 04/04/2023 2699823790 rename attach trigger to attach organization
Akhila 04/05/2023 2699823790 table render company name in phase and fix prepopulation issue
Sohel 04/05/2023 2699823790 Fixed Popup Issue
Akhila 04/17/2023 2699823790 Added Corporate Value Based on Company
Akhila 05/03/2023 2699823790 bug fixed prepopulation on status, company field and table column copmany data
Ravi 05/31/2023 2699823790 changed delete popup message
Akhila 05/31/2023 2699823790 unsaved changes bug fixed
*/
import React, {createRef, useState, useEffect} from 'react';
import {Grid, Tooltip} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../components/DialogBox';
import AttchedTriggersForm from './AttchedTriggersForm';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {useSelector, useDispatch} from 'react-redux';
import {fetchCompanyDropDownData} from '../../../../redux/reducers/clientMangement/Organizaation';

// import { getObject } from "../../../../util/GetDropdownObject";
export default function AddClientTable({
  setAttachedTriggersData,
  AttachedTriggersData,
  deletedClientData,
  setDeletedClientData,
  eventType,
  eventCode,
  eventDescription,
  editExisting,
  handleDirty,
}) {
  const [openPopup, setOpenPopup] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [clientRowData, setClientRowData] = useState({});
  const [unique, setUnique] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const dispatch = useDispatch();
  const disable = roleData?.window?.['Event Triggers']?.['ET'];
  const {companyAPIdata} = useSelector(({organization}) => organization);
  useEffect(() => {
    dispatch(fetchCompanyDropDownData());
  }, [dispatch]);
  const getObjects = (option, options) => {
    let label = {};
    const option1 = Number(option);
    option1 &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.companyId === option1) {
          label = item;
        }
      });
    return label;
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  const handleAttachedTriggersClose = () => {
    setOpenPopup(false);
    setIsEdit(false);
  };

  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        const dataDelete = [...AttachedTriggersData];
        const index = deleteData.tableData.id;
        dataDelete.splice(index, 1);
        setAttachedTriggersData([...dataDelete]);
        deletedClientData?.length > 0 ?
          setDeletedClientData([...deletedClientData, deleteData?.id]) :
          deleteData?.id ?
            setDeletedClientData([deleteData?.id]) :
            setDeletedClientData([]);
        resolve();
        setIsDelete(false);
      }, 1000);
      handleDirty(true);
    });

  const columns = [
    {
      title: 'Seq',
      field: 'seq',
      render: (rowData) => {
        const rowSeqNo = rowData?.tableData?.id ?
          rowData?.tableData?.id + 1 :
          rowData?.tableData?.id === 0 ?
            1 :
            '';
        AttachedTriggersData[rowData.tableData.id].seqNo = rowSeqNo;
        return rowSeqNo;
      },
    },
    {
      title: 'Type',
      field: 'type',
      render: (rowData) => rowData?.type || '-',
    },
    {
      title: 'Company',
      render: (rowData) =>
        rowData?.phase ? getObjects(rowData?.phase, companyAPIdata)?.companyName : '-',
      // rowData?.phase ? getObject(rowData?.phase?.toString(), PHASE, dropDownData)?.value : "-",
    },
    {
      title: 'Corporate',
      render: (rowData) => (rowData?.corporateName ? rowData?.corporateName : '-'),
    },
    {
      title: 'SiteName',
      render: (rowData) => (rowData?.siteName ? rowData?.siteName : '-'),
    },

    {
      title: 'Department Code',
      field: 'clientCode',
      render: (rowData) => (rowData?.clientCode ? rowData?.clientCode?.toUpperCase() : '-'),
    },
    {
      title: 'Triggers',
      render: (rowData) => {
        return rowData?.eventTactic?.map((i, index) => <div key={index}>{i?.code}</div>);
      },
    },
    {
      title: 'Continue After Processing',
      field: 'correspondingClients',
      render: (rowData) => (rowData?.correspondingClients ? rowData?.correspondingClients : '-'),
    },
  ];
  const tableRef = createRef();

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title={'Delete Attached Organization'}
        value={`Are you sure you want to delete Attached Organization?`}
        handleSubmit={handleConfirmDelete}
      />
      <DialogBox
        open={openPopup || isEdit}
        dialogClose={handleAttachedTriggersClose}
        title={'Attach Organization'}
        maxWidth="lg"
        hideFooter={true}
      >
        <AttchedTriggersForm
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          setAttachedTriggersData={setAttachedTriggersData}
          AttachedTriggersData={AttachedTriggersData}
          setOpenPopup={setOpenPopup}
          clientRowData={clientRowData}
          unique={unique}
          setUnique={setUnique}
          eventType={eventType}
          eventCode={eventCode}
          eventDescription={eventDescription}
          handleDirty={handleDirty}
        />
      </DialogBox>
      <Grid item xs={12}>
        <div className="new-standard-textfields custom-table global-field-table custom-actions-icon custom-toolbar-icons trigger-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={AttachedTriggersData || []}
            tableRef={tableRef}
            textAlign="left"
            options={{
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              paging: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon />
                  </>
                ),
                tooltip: 'Edit',
                disabled: editExisting && !disable?.edit,
                onClick: (event, rowData) => {
                  setClientRowData(rowData);
                  setIsEdit(true);
                },
              },
              {
                icon: () =>
                  eventType ? (
                    <span>
                      <Button
                        variant="outlined"
                        className="search-btn"
                        disabled={editExisting && !disable?.edit}
                        onClick={() => {
                          setOpenPopup(true);
                        }}
                      >
                        <AddIcon /> Attach Organization
                      </Button>
                    </span>
                  ) : (
                    <Tooltip title="Please Select Event Type">
                      <span>
                        <Button variant="outlined" className="search-btn" disabled>
                          <AddIcon /> Attach Organization
                        </Button>
                      </span>
                    </Tooltip>
                  ),
                isFreeAction: true,
                onClick: () => {},
                disabled: !eventType || (editExisting && !disable?.edit),
              },
              (rowData) => {
                return {
                  icon: () => (
                    <>
                      <DeleteOutlineOutlinedIcon />
                    </>
                  ),
                  tooltip: 'Delete',
                  disabled: editExisting && !disable?.delete,
                  onClick: () => {
                    setIsDelete(true);
                    setDeleteData(rowData);
                  },
                };
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
}
